module.exports = __webpack_public_path__ + "static/media/rome-10.0cac9930.jpg";